module.exports = __webpack_public_path__ + "img/fb-messenger.985ba843.svg";